import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const UserCircleSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  const { className = '', ...rest } = props

  return (
    <div {...rest} className={`inline-flex items-center justify-center ${className}`}>
      <svg className="block w-full h-full" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="8.25" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="12" cy="10" r="2.25" stroke="currentColor" strokeWidth="1.5" />
        <path
          d="M7.5 17.1C8.2 15.4 9.9 14.4 12 14.4C14.1 14.4 15.8 15.4 16.5 17.1"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </div>
  )
}

export default UserCircleSvg
